import { History, X } from "lucide-react";
import { DISPLAY } from "./BlackFriday";

const KEY = "scutersh:recent";
const MAX = 8;

export const getRecentIds = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

export const addRecentId = id => {
  const ids = [id, ...getRecentIds().filter(x => x !== id)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(ids));
  return ids;
};

export function RecentlyViewed({ ids, scooters, onOpen, onClear }) {
  const items = ids.map(id => scooters.find(s => s.scooter_id === id)).filter(Boolean);
  if (items.length === 0) return null;
  return (
    <div data-testid="recently-viewed" className="bg-[#13131A] border border-[#262636] rounded-lg p-3 sm:p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className={`${DISPLAY} font-extrabold text-xl text-white flex items-center gap-2`}><History className="w-5 h-5 text-[#FF0033]" />Văzute recent</h3>
        <button data-testid="recently-viewed-clear" onClick={onClear} className="text-xs text-slate-500 hover:text-white flex items-center gap-1"><X className="w-3 h-3" />Șterge</button>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1">
        {items.map(s => (
          <button key={s.scooter_id} data-testid={`recent-${s.scooter_id}`} onClick={() => onOpen(s, "scooter")}
            className="flex-shrink-0 w-36 text-left rounded-md overflow-hidden border border-[#262636] hover:border-[#FF0033]/60 transition-colors bg-[#0A0A0E]">
            <div className="aspect-[4/3] bg-black">
              {s.photos?.[0] && <img src={s.photos[0]} alt={`${s.brand} ${s.model}`} loading="lazy" className="w-full h-full object-cover" />}
            </div>
            <div className="p-2">
              <p className="text-xs font-semibold text-white truncate">{s.brand} {s.model}</p>
              <p className="text-xs font-['Russo_One','Exo_2'] [font-synthesis:none] font-bold text-[#FF0033]">{s.selling_price} EUR</p>
              {s.status === "sold" && <p className="text-[10px] text-slate-500">Vândut</p>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
